import React, { Component } from "react";
import { connect } from "react-redux";
import "./SubmitButton.component.scss";
import { SubmitButtonStrings } from "./SubmitButton.strings";
import {authStoreSelectors} from "../../../../store/store";

export interface SubmitButtonExistAccountProps {
    onChangePage: any;
}

class SubmitButtonExistAccount extends Component<SubmitButtonExistAccountProps, {}> {



    render() {
        let message = SubmitButtonStrings.LOGIN;

        return (
            <div id="SubmitButtonNewAccount">
                <button
                    type="button"
                    onClick={() => this.props.onChangePage(0)}
                    className="grey-btn-negative">
                    {message}
                </button>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    redirectLogin: authStoreSelectors.redirectLogin(state)
});

export default connect(
    mapStateToProps,
    null
)(SubmitButtonExistAccount);
